import { logger } from 'utils/logging'

const providersReportedToSentry = new Set<string>()

/**
 * Runs one provider's fan-out step. Analytics is best-effort and is logged from inside UI
 * handlers, so a throwing provider must not abort the action or skip the others (ISSUE-3098).
 *
 * Standalone module so the provider controllers can use it without importing analyticsUtils, which imports them.
 */
export const runProvider = (provider: string, event: string, call: () => void) => {
  try {
    call()
  } catch (error) {
    try {
      // Dev-host console on every occurrence, one Sentry report per provider per session carrying
      // the exception: a permanently broken provider would otherwise flood the quota (cf. ISSUE-2943).
      const message = `Analytics provider "${provider}" failed`
      const context = { component: 'analytics', action: provider, metadata: { event } }

      if (providersReportedToSentry.has(provider)) {
        logger.warn(message, { event, error }, { sentry: false, context })
      } else {
        providersReportedToSentry.add(provider)
        logger.error(message, error instanceof Error ? error : new Error(String(error)), { sentry: true, context })
      }
    } catch {
      // Reporting a broken reporter must not throw either.
    }
  }
}
